import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { get } from 'lodash';
import { extractErrorsForNestedAttributes } from '../Services/ApiErrorHelpers';
import { MutationConfig } from '../Services/queriesConfig';

export interface useApiMutationProps<T> {
  query: MutationConfig<T>;
  onSuccess?: (response: any) => void;
  onError?: (errors: any, data: any) => void;
  onSettled?: (response: any) => void;
}

function useApiMutation<T>({
  query,
  onSuccess = () => {},
  onError = () => {},
  onSettled = () => {},
}: useApiMutationProps<T>) {
  const queryClient = useQueryClient();

  const [errors, setErrors] = useState({});
  const mutation = useMutation({
    mutationFn: query.mutationFn,
    throwOnError: true,
    onSuccess: (response: any) => {
      if (response.ok) {
        onSuccess(get(response, 'data.data'));
      } else {
        const apiErrors = extractErrorsForNestedAttributes(response);

        setErrors(apiErrors);
        onError(apiErrors, response.data);
      }
    },
    onSettled,
  });

  return {
    ...mutation,
    data: get(mutation, 'data.data'),
    queryClient,
    errors,
  };
}

export default useApiMutation;
